import { Component, OnInit, NgZone } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { Router } from '@angular/router';;
import { UtilService } from 'src/app/services/util.service';
import { STORAGE_PUSH_SUBSCRIPTIONS, STORAGE_LAST_RESTAURANT } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';

import { PushService, TOPIC_RESTAURANT_IS_OPENING, TOPIC_NEW_CONTACT_MESSAGE } from 'src/app/services/push.service';
import { ImageService } from 'src/app/services/image.service';
import { WifiService } from 'src/app/services/wifi.service';
import { SettingsProvider } from 'src/app/services/settings.service';
import { BonuskarteService } from 'src/app/services/bonuskarte.service';
import { Special } from 'src/app/models/special.model';
import { ANALYTICS_EV_SPECIAL_CLICK, ANALYTICS_EV_OPEN_MENU } from 'src/environments/constant';
import { CoronaService } from 'src/app/pages/shared/corona/corona.service';
import { Table } from 'src/app/models/table.model';

//declare var google;

@Component({
  selector: 'app-customer-home',
  templateUrl: './customer-home.page.html',
  styleUrls: ['./customer-home.page.scss'],
})
export class CustomerHomePage implements OnInit {
  // @ViewChild('imgCard', {static: false}) imgCard;
  // @ViewChild('img', {static: false}) img;
  selectedTheme: String;

  constructor(private router: Router, public db: DBService, public imageService: ImageService, private ngZone: NgZone, public bonuskartenService: BonuskarteService,
    public util: UtilService, public userService: UserService, private pushService: PushService, public wifiService: WifiService, private settings: SettingsProvider,
    public coronaService: CoronaService) {

    this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);
  }

  pressed() {
    console.log("pressed")
  }
  active() {
    console.log("active")
  }
  released() {
    console.log("released")
  }

  ionViewWillEnter() {
    this.db.setPage('home')
    this.util.popover.dismiss();
  }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))

      return
    }

    this.updateConnection2WifiAvailable();

    //Nur temporaer damit ich Push Notifications erhalte
    //this.pushService.subscribeToTopic(TOPIC_NEW_CONTACT_MESSAGE)

    //Damit man beim Oeffnen der App wieder im gleichen Restaurant ist
    localStorage.setItem(STORAGE_LAST_RESTAURANT, JSON.stringify(this.db.currentRestaurantKey))

    this.db.setPage('home')

    this.initUser();

    //Predefined tables via URL + corona registration form
    if (this.util.sourceParam) {
      if (this.db.currentRestaurant.tables.find((table: Table) => table.qrCode === this.util.sourceParam) !== undefined) {
        this.userService.currentTable = this.db.currentRestaurant.tables.find((table: Table) => table.qrCode === this.util.sourceParam)
        if (this.db.currentRestaurant.guestRegistration && !this.coronaService.currentGroup.checkedIn) this.openCorona()
      }

      this.util.sourceParam = undefined
    }

    if (this.util.targetParam) {
      if (this.util.targetParam == "calendar"){
        this.openCalendar();
      }

      this.util.targetParam = undefined
    }

    /*
    // set certain preferences
    if (this.appRate && this.appRate.preferences) {
      this.appRate.preferences.storeAppURL = {
        ios: '1465318633',
        android: 'market://details?id=de.barela',
        windows: 'ms-windows-store://review/?ProductId=NOT_SUPPORTED_XYZ_CRAP'
      }

      this.appRate.promptForRating(true);

      // or, override the whole preferences object
      this.appRate.preferences = {
        usesUntilPrompt: 5,
        storeAppURL: {
          ios: '1465318633',
          android: 'market://details?id=de.barela',
          windows: 'ms-windows-store://review/?ProductId=NOT_SUPPORTED_XYZ_CRAP'
        }
      }

      this.appRate.promptForRating(false);
    } else {
      //TODO keine apprate zur verfuegung
    }
    */

    //Mach Best Guess, vll. geht ja WifiWizard2 Direkt :)
    //this.wifiService.initStartWifiScreening();
  }

  ngAfterViewInit() {
    /*
    setTimeout(() => {
      let imgCardWidth = this.imgCard.el.offsetWidth;
      if (imgCardWidth > 287) {
        this.img.el.setAttribute("style", "height: 100% !important; width: 100% !important;object-fit: cover;");
      }
    }, 200);*/
  }

  get activeSpecials(): any[] {
    if (!this.db.currentRestaurant.special2 || this.db.currentRestaurant.special2.length === 0)
      return [];
    else {
      return this.db.currentRestaurant.special2.filter(special => {
        return special.isActive;
      });
    }
  }

  getImgUrl(img: string) {
    let url: string = ''
    if (img) {
      if (img.includes("http")) url = img
      else url = "/" + img
    } else
      url = "/assets/imgs/specials/special_15.jpg"

    return 'url(' + url + ')'
  }

  openBonuskarten() {
    this.ngZone.run(() => this.router.navigate(['/bonuskarte-customer']))
  }

  openCorona() {
    this.ngZone.run(() => this.router.navigate(['/corona']))
  }

  openBasket() {
    this.ngZone.run(() => this.router.navigate(['/basket']))
  }

  //Oeffnet Speisekarte
  openOrdering() {
    this.db.addAnalytics(ANALYTICS_EV_OPEN_MENU)
    //this.events.publish('resetItems')
    this.ngZone.run(() => {
      this.router.navigate(['/menu'])
    })
  }

  openLinkSpecial(specialObj: Special) {
    this.db.addAnalytics(ANALYTICS_EV_SPECIAL_CLICK, { "specialId": specialObj.id, "specialName": specialObj.title })
    this.ngZone.run(() => {
      if (specialObj.bonuscardSpecial)
        this.router.navigate(['/bonuskarte-customer'])
      else if (specialObj.id2Link) {
        localStorage.setItem('openID', JSON.stringify(specialObj.id2Link))
        this.router.navigate(['/menu'])
      } else {
        this.router.navigate(['/menu'])
      }
    })
  }

  openLocalInfo() {
    this.ngZone.run(() => this.router.navigate(['/local-info']))
  }

  openReservation() {
    this.ngZone.run(() => this.router.navigate(['/reservation-customer']))
  }

  openMeineBestellungen() {
    //this.db.setPage('order')
    this.ngZone.run(() => this.router.navigate(['/order']))
  }

  openOpeningTimes() {
    this.ngZone.run(() => this.router.navigate(['/opening-time']))
  }

  openCalendar() {
    this.ngZone.run(() => this.router.navigate(['/calendar']))
  }
  
  setPage(componentName: string) {
    this.ngZone.run(() => this.db.setPage(componentName))
  }

  /**
   * Back Button in footer
   * @param currentPage 
   */
  back(currentPage: string) {
    this.util.log("aktuelle seite in back()", currentPage)
    switch (currentPage) {
      case 'home':
        localStorage.removeItem(STORAGE_LAST_RESTAURANT)
        this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
        break;
      case 'map':
      case 'info':
      case 'employees':
      case 'order':
        this.db.setPage('home')
        break;
      case 'basket':
        this.db.setPage('home')
        break;
      default:
        localStorage.removeItem(STORAGE_LAST_RESTAURANT)
        this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
    }

  }

  initUser() {
    if (!this.userService.hasInitialized) {
      this.initPushSubscription();
    }
  }

  initPushSubscription() {
    let val: any = localStorage.getItem(STORAGE_PUSH_SUBSCRIPTIONS)
    if (val) {
      this.userService.pushSubscription = JSON.parse(val)
    } else {
      this.userService.pushSubscription = {};
    }

    for (let key of Object.keys(this.db.restaurants)) {
      if (this.userService.pushSubscription[key] === true) {
        this.pushService.subscribeToTopic(TOPIC_RESTAURANT_IS_OPENING, key)
      } else {
        this.pushService.unsubscribeToTopic(TOPIC_RESTAURANT_IS_OPENING, key)
      }
    }
  }


  /**
   * Returns last orderd service to customer within 1 hour which was not set to "done"
   */
  get openServiceName(): string {
    let now: number = new Date().getTime()
    for (let orderGroup of this.db.myPrivateOrders) {
      if (orderGroup.isService && (now - orderGroup.timestamp < 3600000) && orderGroup.restaurantKey === this.db.currentRestaurantKey) {
        if (orderGroup.order && orderGroup.order.length == 1 && orderGroup.order[0].state != 2) {
          return orderGroup.order[0].fixedItemName
        }
      }
    }

    return undefined;
  }


  /** WifiWizard2 */
  updateConnection2WifiAvailable() {
    let wifis: any[] = this.db.currentRestaurant.wifi2 ? this.db.currentRestaurant.wifi2 : []

    for (let wifi of wifis) {
      if (wifi.password && wifi.password.length > 0) {
        this.util.wifiConnectionAvailable = true
        return
      }
    }

    this.util.wifiConnectionAvailable = false
  }


}
